import styled from 'styled-components';

import IconLocationPinMono from '@/components/atom/icon/IconLocationPinMono';
import theme from '@/styles/theme';

interface ResultSectionProps {
  title: string;
  hasResultData: boolean;
  children?: React.ReactNode;
}

const ResultSection = ({ title, children, hasResultData }: ResultSectionProps) => {
  if (!hasResultData) return <></>;

  return (
    <section className='border-gray-30 border-b-[16px] border-solid py-[28px]'>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </section>
  );
};

interface ResultProps {
  children: React.ReactNode;
}

const Result = ({ children }: ResultProps) => {
  return <ResultWrapper>{children}</ResultWrapper>;
};

const ResultWrapper = styled.div`
  > div:not(:last-child) {
    border-bottom-width: 1px;
    border-bottom-color: ${({ theme }) => theme.color.gray40};
    border-bottom-style: solid; 
  }
`;

interface MoreButtonProps {
  onClick: () => void;
}

const MoreButton = ({ onClick }: MoreButtonProps) => {
  return (
    <div
      onClick={onClick}
      className='mx-[24px] mt-[12px] flex h-[40px] items-center justify-center rounded-[8px] border-[1px] border-gray-50 border-solid bg-white py-[12px]'
    >
      <span className='typography-15sb text-gray-600'>더보기</span>
    </div>
  );
};

interface ResultAddressProps {
  address: string;
  getCurrentLocation: () => void;
  marginTop?: number;
}

const ResultAddress = ({ address, getCurrentLocation, marginTop = 12 }: ResultAddressProps) => {
  return (
    <AddressWrapper marginTop={marginTop}>
      <Address>
        <IconLocationPinMono size={16} fill={theme.color.gray700} />
        {address}
      </Address>
      <Subtitle role='button' onClick={getCurrentLocation}>
        현재 위치로 설정
      </Subtitle>
    </AddressWrapper>
  );
};

ResultSection.Result = Result;
ResultSection.MoreButton = MoreButton;
ResultSection.ResultAddress = ResultAddress;

export default ResultSection;

const SectionTitle = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 0 24px 12px;
  align-items: center;
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray500};
`;

const AddressWrapper = styled.div<{ marginTop: number }>`
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  height: 48px;
  display: flex;
  align-items: center;
  margin-top: ${({ marginTop }) => `${marginTop}px`};
  justify-content: space-between;
  background-color: ${({ theme }) => theme.color.gray30};
`;

const Address = styled.div`
  ${({ theme }) => theme.typography.UI14M};
  color: ${({ theme }) => theme.color.gray700};
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 6px;
  }
`;

const Subtitle = styled.span`
  ${({ theme }) => theme.typography.UI14R};
  color: ${({ theme }) => theme.color.gray300};
  text-decoration: underline;
  cursor: pointer;
`;
